import {
  Game,
  GameCollection,
  GameCollectionListField,
  GameListField,
  GameStatistics,
  GameStatisticsListField,
  GameStoreState,
} from '../../models/GameStore';
import { Cursor } from '../../models/Repository';

export const getGameCollections = (
  state: GameStoreState,
  fieldName: GameCollectionListField,
) => state.gameCollections.list(fieldName).get();

export const getGameCollection = (
  state: GameStoreState,
  gameCollectionId: string,
) => state.gameCollections.get(gameCollectionId);

export const removeGameCollection = (
  state: GameStoreState,
  gameCollection: GameCollection,
) => state.gameCollections.delete(gameCollection.id());

export const setGameCollections = (
  state: GameStoreState,
  fieldName: GameCollectionListField,
  ...gameCollections: GameCollection[]
) => {
  state.gameCollections.list(fieldName).set(...gameCollections);
};
export const updateGameCollection = (
  state: GameStoreState,
  gameCollection: GameCollection,
) => {
  state.gameCollections.set(gameCollection);
};

export const pushGameCollections = (
  state: GameStoreState,
  fieldName: GameCollectionListField,
  ...gameCollections: GameCollection[]
) => {
  state.gameCollections.list(fieldName).push(...gameCollections);
};

export const setGameCollectionCursor = (
  state: GameStoreState,
  fieldName: GameCollectionListField,
  cursor: Cursor,
) => {
  state.gameCollections.list(fieldName).setCursor(cursor);
};

export const getGame = (state: GameStoreState, GameId: string) =>
  state.games.get(GameId);

export const removeGame = (state: GameStoreState, game: Game) =>
  state.games.delete(game.id());

export const setGames = (
  state: GameStoreState,
  fieldName: GameListField,
  ...games: Game[]
) => {
  state.games.list(fieldName).set(...games);
};

export const pushGames = (
  state: GameStoreState,
  fieldName: GameListField,
  ...games: Game[]
) => {
  state.games.list(fieldName).push(...games);
};

export const getGameStatistics = (state: GameStoreState, gameId: string) =>
  state.gameStatistics.get(gameId);

export const getGameStatisticsList = (
  state: GameStoreState,
  fieldName: GameStatisticsListField,
) => state.gameStatistics.list(fieldName).get();

export const setGameStatisticss = (
  state: GameStoreState,
  fieldName: GameStatisticsListField,
  ...gameStatistics: GameStatistics[]
) => {
  state.gameStatistics.list(fieldName).set(...gameStatistics);
};
export const updateGameStatistics = (
  state: GameStoreState,
  gameStatistics: GameStatistics,
) => {
  state.gameStatistics.set(gameStatistics);
};

export const pushGameStatistics = (
  state: GameStoreState,
  fieldName: GameStatisticsListField,
  ...gameStatistics: GameStatistics[]
) => {
  state.gameStatistics.list(fieldName).push(...gameStatistics);
};
